// extracted by mini-css-extract-plugin
export default {"container":"yK-z","topReviewHeading":"zK-z","criticalReview":"AK-z","favorableReview":"BK-z","vsSeparator":"CK-z"};